import React, { Component } from 'react';
import radium from 'radium';

import {
  cardRow1,
  cardRow2,
} from '../mocks/block4.js';
import arrowLeft from '../static/images/Block4/arrowLeft.png';
import arrowRight from '../static/images/Block4/arrowRight.png';
import block4TitleBg from '../static/images/Block4/block4TitleBg.png';
import cheeringStick from '../static/images/Block4/cheeringStick.png';
import doubleCheeringStick from '../static/images/Block4/doubleCheeringStick.png';
import coloredBall from '../static/images/Block4/coloredBall.png';
import home from '../static/images/Block4/home.png';

const styles = {
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '50px 0',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleBlock: {
    width: 270,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EE8356',
    borderRadius: '20px',
    color: 'white',
    fontWeight: 600,
    letterSpacing: '3px',
    position: 'absolute',
    zIndex: 3,
  },
  doubleCheeringStick: {
    width: 70,
    position: 'absolute',
    left: -10,
    bottom: -18,
    zIndex: 4,
  },
  coloredBall: {
    width: 60,
    position: 'absolute',
    right: -20,
    bottom: -14,
    zIndex: 4,
  },
  block4TitleBg: {
    width: 153,
    position: 'absolute',
    margin: 'auto',
    left: 0,
    right: 0,
    bottom: -26,
    zIndex: 2,
  },
  titleInnerWrapper: {
    position: 'relative',
    width: 270,
    height: 40,
    marginBottom: 50,
  },
  boardWrapper: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  boardCenter: {
    width: 900,
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    margin: '16px 25px 0px 25px',
    '@media (max-width: 534px)': {
      width: '100%',
      margin: '10px 0px 0px 0px',
    },
    '@media (min-width: 768px) and (max-width: 1023px)': {
      width: 610,
      margin: '12px 24px 0px 24px',
    },
    // '@media (min-width: 535px) and (max-width: 767px)': {
    //   width: 405,
    //   margin: '12px 24px 0px 24px',
    // },
  },
  cardsWrapper: {
    display: 'flex',
    width: '100%',
    maxWidth: 900,
    justifyContent: 'flex-start',
    margin: '16px 25px 0px 25px',
    '@media (max-width: 534px)': {
      width: '100%',
      margin: '10px 0px 0px 0px',
      overflow: 'auto',
      padding: '0 20px',
    },
    '@media (min-width: 535px) and (max-width: 1023px)': {
      margin: '12px 24px 0px 24px',
    },
  },
  card: {
    display: 'flex',
    width: 280,
    height: 502,
    flexFlow: 'column',
    alignItems: 'center',
    backgroundColor: 'rgb(251, 252 ,231)',
    margin: 8,
    borderRadius: 8,
    '@media (max-width: 1023px)': {
      height: 422,
      margin: 3,
    },
    '@media (max-width: 414px)': {
      height: 400,
      margin: 3,
    },
  },
  sticker: {
    width: 120,
    height: 120,
    borderRadius: '50%',
    margin: '25px 50px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    position: 'relative',
    '@media (max-width: 1023px)': {
      width: 90,
      height: 90,
      margin: '8px 50px',
    },
  },
  cheeringSticker: {
    width: 135,
    height: 135,
    borderRadius: '50%',
    margin: '80px 50px',
    position: 'relative',
    backgroundColor: '#EE8356',
  },
  nameText: {
    margin: 0,
    fontSize: 15,
    color: '#537233',
    '@media (max-width: 767px)': {
      fontSize: 14,
    },
  },
  titleText: {
    margin: '4px 0 0',
    fontSize: 13,
    maxWidth: 220,
    color: 'rgb(196, 105, 71)',
    '@media (max-width: 767px)': {
      fontSize: 13,
    },
  },
  context: {
    width: 185,
    margin: '8px 18px',
    fontSize: 13,
    color: '#537233',
    lineHeight: 1.4,
    '@media (max-width: 767px)': {
      fontSize: 12,
      padding: '0 4px',
    },
  },
  cheeringStick: {
    width: 100,
    position: 'absolute',
    top: 40,
    right: -40,
    '@media (max-width: 1023px)': {
      width: 70,
      height: 70,
      top: 30,
      right: -30,
    },
  },
  leftArrowButton: {
    backgroundImage: `url(${arrowLeft})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    height: 35,
    width: 21,
    margin: 0,
    backgroundColor: 'transparent',
    outline: 'none',
    cursor: 'pointer',
    border: 'none',
    '@media (max-width: 534px)': {
      display: 'none',
    },
  },
  rightArrowButton: {
    backgroundImage: `url(${arrowRight})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    height: 35,
    width: 21,
    margin: 0,
    outline: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    border: 'none',
    '@media (max-width: 534px)': {
      display: 'none',
    },
  },
  disabledButton: {
    opacity: 0.2,
    cursor: 'initial',
  },
  home: {
    width: 80,
    position: 'absolute',
    margin: 'auto',
    top: 10,
    right: 0,
    left: 0,
  },
  smallDoubleStick: {
    width: 60,
    position: 'absolute',
    left: 38,
    top: 26,
  },
  stickerText: {
    margin: 0,
    position: 'absolute',
    bottom: 21,
    left: 26,
    color: 'white',
    fontWeight: 600,
  },
};

class Block4 extends Component {
  constructor(props) {
    super(props);

    let appearNum = 3;
    let toOneRow = false;

    if (window.matchMedia('(max-width: 534px)').matches) {
      appearNum = cardRow1.length + cardRow2.length;
      toOneRow = true;
    } else if (window.matchMedia('(max-width: 767px) and (min-width: 535px)').matches) {
      appearNum = 2;
    } else if (window.matchMedia('(max-width: 1023px) and (min-width: 768px)').matches) {
      appearNum = 3;
    } else if (window.matchMedia('(max-width: 1179px) and (min-width: 1024px)').matches) {
      appearNum = 3;
    }

    this.state = {
      firstCardNo: 0,
      appearNum,
      toOneRow,
    };

    this.resizeHandler = () => this.handleResizing();
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  handleResizing() {
    const width = window.innerWidth;

    if (width < 535) {
      this.setState({
        firstCardNo: 0,
        appearNum: cardRow1.length + cardRow2.length,
        toOneRow: true,
      });
    } else if (width >= 535 && width < 768) {
      this.setState({
        firstCardNo: 0,
        appearNum: 2,
        toOneRow: false,
      });
    } else if (width >= 768 && width < 1024) {
      this.setState({
        firstCardNo: 0,
        appearNum: 2,
        toOneRow: false,
      });
    } else if (width >= 1024 && width < 1180) {
      this.setState({
        firstCardNo: 0,
        appearNum: 3,
        toOneRow: false,
      });
    } else if (width >= 1180) {
      this.setState({
        firstCardNo: 0,
        appearNum: 3,
        toOneRow: false,
      });
    }
  }

  render() {
    const {
      firstCardNo,
      appearNum,
      toOneRow,
    } = this.state;

    const leftArrowButoonDisabled = firstCardNo === 0;
    const rightArrowButoonDisabled = firstCardNo + appearNum >= cardRow1.length;

    return (
      <div style={styles.wrapper}>
        <div style={styles.titleWrapper}>
          <div style={styles.titleInnerWrapper}>
            <div style={styles.titleBlock}>
              熱血應援大聲說
            </div>
            <img style={styles.doubleCheeringStick} alt="兩根加油棒" src={doubleCheeringStick} />
            <img style={styles.block4TitleBg} alt="彩帶" src={block4TitleBg} />
            <img style={styles.coloredBall} alt="彩球" src={coloredBall} />
          </div>
        </div>
        <div style={styles.boardWrapper}>
          <button
            type="button"
            disabled={leftArrowButoonDisabled}
            onClick={() => {
              this.setState(state => ({
                firstCardNo: state.firstCardNo - appearNum,
              }));
            }}
            style={[
              styles.leftArrowButton,
              leftArrowButoonDisabled ? styles.disabledButton : null,
            ]} />
          <div style={styles.boardCenter}>
            {toOneRow ? (
              <div key="oneRow" style={styles.cardsWrapper} className="scroll">
                {cardRow1
                  .slice(0, 4)
                  .concat(cardRow2.slice(0, 4))
                  .concat(cardRow1.slice(4, 8))
                  .concat(cardRow2.slice(4, 8))
                  .slice(firstCardNo, firstCardNo + appearNum)
                  .map(card => (
                    <div
                      key={`oneRow-${card.id}`}
                      style={styles.card}>
                      <div style={[styles.sticker, { backgroundImage: `url(${card.image})` }]}>
                        <img style={styles.cheeringStick} src={cheeringStick} alt="加油棒" />
                      </div>
                      <p style={styles.nameText}>
                        {card.name}
                      </p>
                      <p style={styles.titleText}>
                        {card.title}
                      </p>
                      <p style={styles.context}>
                        {card.context}
                      </p>
                    </div>
                  ))}
              </div>
            ) : [
              <div key="twoRow-1" style={styles.cardsWrapper} className="scroll">
                {cardRow1.slice(firstCardNo, firstCardNo + appearNum).map(card => (
                  <div
                    key={`row1-${card.id}`}
                    style={styles.card}>
                    <div style={[styles.sticker, { backgroundImage: `url(${card.image})` }]}>
                      <img style={styles.cheeringStick} src={cheeringStick} alt="加油棒" />
                    </div>
                    <p style={styles.nameText}>
                      {card.name}
                    </p>
                    <p style={styles.titleText}>
                      {card.title}
                    </p>
                    <p style={styles.context}>
                      {card.context}
                    </p>
                  </div>
                ))}
              </div>,
              <div key="twoRow-2" style={styles.cardsWrapper} className="scroll">
                {cardRow2.slice(firstCardNo, firstCardNo + appearNum).map(card => (
                  <div
                    key={`row2-${card.id}`}
                    style={styles.card}>
                    <div style={[styles.sticker, { backgroundImage: `url(${card.image})` }]}>
                      <img style={styles.cheeringStick} src={cheeringStick} alt="加油棒" />
                    </div>
                    <p style={styles.nameText}>
                      {card.name}
                    </p>
                    <p style={styles.titleText}>
                      {card.title}
                    </p>
                    <p style={styles.context}>
                      {card.context}
                    </p>
                  </div>
                ))}
              </div>,
            ]}
          </div>
          <button
            type="button"
            disabled={rightArrowButoonDisabled}
            onClick={() => {
              this.setState(state => ({
                firstCardNo: state.firstCardNo + appearNum,
              }));
            }}
            style={[
              styles.rightArrowButton,
              rightArrowButoonDisabled ? styles.disabledButton : null,
            ]} />
        </div>
        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/556055591230516/posts/1064278483741555/" style={styles.cheeringSticker}>
          <img style={styles.smallDoubleStick} src={doubleCheeringStick} alt="加油棒" />
          <img style={styles.home} src={home} alt="家" />
          <p style={styles.stickerText}>
            應援跟我來!
          </p>
        </a>
      </div>
    );
  }
}

export default radium(Block4);
